import * as Yup from 'yup';

export const validationSchemaRegister = new Yup.ObjectSchema({
    email:Yup.string().required('Cannot be empty').email('Invalid email'),
    password: Yup.string().required('Password is required').min(6,'Password should be atleast 6 character long'),
    // passwordConfirm: Yup.string().required('Confirm Password is required').oneOf([Yup.ref('password'), null], 'Passwords must match'),
    name: Yup.string().required('Cannot be empty'),
    // number: Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/,'Please enter 10 digit phone number'),
    // address: Yup.string().required('Cannot be empty'),
    // owner: Yup.string().required('Cannot be empty'),
    business_type: Yup.number().required('Cannot be empty').notOneOf([0], 'Cannot be empty'),
});

export const initialValuesRegister = {
    email:'',
    name:'',
    password:'',
    passwordConfirm:'',
    number:'',
    address:'',
    owner:'',
    business_type:0,
}

export const feildsRegister =(options=[]) => [
    {
        name:'name',
        placeholder:'Enter business name',
        id:'name',
        type:'text',
        label:'Business Name'
    },
    {
        name:'business_type',
        placeholder:'Business type here',
        id:'business_type',
        type:'select',
        options:[
            {
                value:0,
                label:'Select Type',
                disabled:true,
            },
            ...options
        ],
        label:'Industry Type'
    },
    {
        name:'email',
        placeholder:'Enter email id',
        id:'email',
        type:'email',
        label:'Email'
    },

    // {
    //     name:'number',
    //     placeholder:'Enter phone number',
    //     id:'number',
    //     type:'text',
    //     label:'Phone number'
    // },
    // {
    //     name:'owner',
    //     placeholder:'Enter onwer name',
    //     id:'owner',
    //     type:'text',
    //     label:'Owner'
    // },
    
    // {
    //     name:'address',
    //     placeholder:'Enter address here',
    //     id:'address',
    //     type:'text',
    //     label:'Address'
    // },
    {
        name:'password',
        placeholder:'Enter password here',
        id:'password',
        type:'password',
        label:'Password'
    },
    // {
    //     name:'passwordConfirm',
    //     placeholder:'Enter confirm password here',
    //     id:'passwordConfirm',
    //     type:'password',
    //     label:'Confirm Password'
    // },
];